<template>
    <div class="list">

        <van-empty description="暂无数据" v-if="storeList.length == 0" />

        <div class="card" v-for="item of storeList" :key="item.id" @click="openDetail(item)">
            <div>
                <div class="flex_box">
                    <span class="icon">|</span>
                    <span class="title">{{ item.storeName }}</span>
                    <img src="../../assets/normal11.png" class="tag" v-if="item.type == 2" alt="" srcset="" />
                    <img src="../../assets/normal22.png" class="tag" v-if="item.type == 1" alt="" srcset="" />

                </div>
                <p class="tips">
                    <van-icon name="clock-o" /> 发布时间：{{ timeChange(new Date(item.createTime)) }}
                </p>
            </div>
            <van-divider />
            <van-cell title="门店编码" :value="item.storeCode" />
            <van-cell title="定位地址" :value="item.location" />
        </div>
        <div class="btn_bottom">
            <van-button type="primary" class="btn" @click="onClickRight">新建</van-button>
            <!-- <van-button type="primary" class="btn" @click="onClickRight11">新H5定位建</van-button> -->
            <!-- onClickRight -->
        </div>
    </div>
</template>

<script>
import { getStoreList } from '../../apis/storeVisit'
export default {
    data() {
        return {
            storeList: []
        }
    },
    created() {
        // alert(process.env.VUE_APP_SERVER_API)
        this.getData()
        console.log('openId===', localStorage.getItem('openid'))
    },
    methods: {
        /**
         * 时间转换
         */
        timeChange(val) {
            return `${val.getFullYear()}年${val.getMonth() + 1}月${val.getDate()}日 ${val.getHours()}:${val.getMinutes()}`
        },
        getData() {
            let openId = localStorage.getItem('openid');
            getStoreList(openId).then(res => {
                this.storeList = res.data;
            })
        },
        onClickRight() {
            // this.$router.push({
            //     path: '/storevisitdata'
            // })
            window.location.href = '/storevisitdata'
        },
        onClickRight11() {
            let successCallback = (val) => {
                console.log('位置==',val.coords.longitude,val.coords.latitude)
             }
            let errorCallback = (val) => { 
                console.log(val)
            }
            let PositionOptions = {
                enableHighAccuracy: true
            }
            if ('geolocation' in navigator) {
                navigator.geolocation.getCurrentPosition(
                    successCallback,
                    errorCallback,
                    PositionOptions)
            } else {
                console.log('不支持获取定位')
            }
        },
        openDetail(val) {
            this.$router.push({
                path: '/storeVisitDetail',
                query: { id: val.id }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.list {
    height: 100vh;
    background: #F7F7F7;
    padding: 15px 15px 80px 15px;

    .van-cell__value {
        flex: 2;
    }

    .van-divider {
        margin: 8px;
    }
}

.card {
    padding: 8px;
    background-color: #fff;
    text-align: left;
    border-radius: 10px;
    margin-bottom: 15px;

    .flex_box {
        display: flex;
        padding: 10px 8px;

        .icon {
            color: #FF232D;
            font-size: 20px;
            font-weight: bold;
        }

        .title {
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            flex-grow: 1;
            margin-left: 5px;
        }

        .tag {
            width: 44px;
            height: 17px;
        }
    }

    .tips {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        margin: 0 8px;
    }

    .tag {}
}

.btn_bottom {
    position: fixed;
    width: 100%;
    bottom: 20px;
    left: 0;

    .btn {
        width: 80%;
        border-radius: 20px;
        background-color: #FF232D;
        border: 0;
    }
}
</style>